
/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

/*
<!-- <mat-option value='2'>Home Globe - Section 1 (2)</mat-option>
<mat-option value='3'>Home Globe - Section 2 (3)</mat-option> -->
<mat-option value='4'>Summary Dashboard - Key KPIs Circles (4)</mat-option>
<mat-option value='5'>Summary Dashboard - UTr Table (5)</mat-option>
<mat-option value='34'>SDG Contribution Dashboard (34)</mat-option>
<mat-option value='40'>Impact Dashboard - Score as Proportion (40)</mat-option>
 */
export const SUMMARY_DASHBOARD_UTR_TABLE = '5';
